import { render, staticRenderFns } from "./EmbedEventList.vue?vue&type=template&id=159dde02&"
import script from "./EmbedEventList.vue?vue&type=script&lang=ts&"
export * from "./EmbedEventList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports